var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"podcast_iframe"},[_c('iframe',{ref:"anchorIframe",attrs:{"id":"sc-widget","src":this.podcastUrl,"height":"170","max-height":"100%","width":"100%","frameborder":"0","scrolling":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }